export const unityData = {
  isCustomRoom: false,
  isProjectRoom: false,
  roomCameraInfo: {
    distanceToSet: 2.63346148,
    fov: 40,
    xTransRot: 12.0843,
    yTransRot: 207.835,
    zTransRot: 0,
    wTransRot: 0,
    centerObjectxPos: 0.0934909955,
    centerObjectyPos: 0.551749647,
    centerObjectzPos: 0.0186319873,
    isCameraCorrection: false,
    lensShiftY: 0,
    cameraHeight: null,
    cameraRotX: 0,
    cameraRotZ: 0,
    focalLength: 15.4545612,
    isdepthOfField: false,
    selectedObjectName: null,
    blurIntensity: 0,
    xPos: 1.29587734,
    yPos: 1.10306644,
    zPos: 2.29578733,
    cameraName: null,
    resoX: 0,
    resoY: 0,
    sensor_width: 20,
    sensor_height: 11.25,
    horizontalFov: 0,
  },
  roomLightData: [],
  transformData: {},
  roomMetadata: {},
  automationData: {},
  automationObjectsDatas: [],
  culpSkuUsedData: {},
  hasNewLightInfo: false,
  props: [],
  cutOutPropData: {},
  userCameraInfo: [],
  propsHierarchyData: {},
  duplicatePropDatas: [],
  deletedObjectsData: [],
  groupPropsMapping: {},
  materialDetails: [],
  materialVersion: 'V3',
  isTextureCustomizer: true,
};
